// extracted by mini-css-extract-plugin
export default {"cls1":"PaperPreviewList-cls1_lwD","cls2":"PaperPreviewList-cls2__O_ PaperPreviewList-cls1_lwD"};